import { AnyAction } from 'redux';

export const SET_VAULT_LOCK = 'SET_VAULT_LOCK';

interface SetVaultLockAction extends AnyAction {
  type: typeof SET_VAULT_LOCK;
  payload: boolean;
}

export const setVaultLock = (isLocked: boolean): SetVaultLockAction => ({
  type: SET_VAULT_LOCK,
  payload: isLocked,
});
